import { BROADCAST_VALIDATE_JOIN_PARAMS } from '../Types';
import { showModal } from 'actions';
import { INVALID_JOIN_REQUEST } from 'constants/ModalTypes';

const ALPHA_NUM_REGEX = /^[a-z0-9]{24}$/;
/**
 * This creates the action to validate a meeting join request,
 */
function validateBroadcast(teamId, eventId, broadcastId) {
  return dispatch => {
    const isValidParams = [teamId, eventId, broadcastId].every(
      id => id && ALPHA_NUM_REGEX.test(id)
    );

    const request = async apiClient => {
      if (!isValidParams) {
        dispatch(showModal(INVALID_JOIN_REQUEST));
        return isValidParams;
      }
      const { isValid } = await apiClient.broadcast.parameters(
        teamId,
        eventId,
        broadcastId
      );
      if (!isValid) {
        dispatch(showModal(INVALID_JOIN_REQUEST));
      }
      return isValid;
    };

    const action = {
      type: BROADCAST_VALIDATE_JOIN_PARAMS,
      request
    };

    dispatch(action);
  };
}

export default validateBroadcast;
